<template>
  <div class="mdl-layout mdl-js-layout mdl-layout--fixed-header mdl-layout--no-drawer-button">
    <heading></heading>
    <main class="mdl-layout__content"  id="scroll-tab">
      <section class="mdl-layout__tab-panel is-active">
        <router-view></router-view>
      </section>
      <!--<footing></footing>-->
      <div v-show="loading" class="loading" transition="fade">
        <div class="message">
          <div class="spinner">
            <div class="mdl-spinner mdl-js-spinner is-active"></div>
          </div>
          <div class="label">{{ 'general.app.loading.label' | label }}</div>
        </div>
      </div>
    </main>
  </div>

  <div v-show="error.show" class="error" transition="fade">
    <div class="mdl-dialog">
      <h3 class="mdl-dialog__title">{{ 'general.app.error.title' | label}}</h3>
      <div class="mdl-dialog__content">
        <p>
          {{ error.message | label }}
        </p>
        <p v-if="!error.message">
          {{ 'general.app.error.message' | label}}
        </p>
      </div>
      <div class="mdl-dialog__actions">
        <div class="mdl-button mdl-js-button mdl-button--colored"
             v-on:click="$emit('dismis-error')">{{ 'general.app.dialog.close' | label}}</div>
      </div>
    </div>
  </div>

  <div v-el:successresult class="mdl-js-snackbar mdl-snackbar">
    <div class="mdl-snackbar__text"></div>
    <button class="mdl-snackbar__action" type="button"></button>
  </div>
</template>

<script>
  var store = require('common/store')
  var local = require('common/store/local')
  var actions = require('common/store/actions')
  var getters = require('common/store/getters')
  var label = require('vue').filter('label')
  var Vue = require('vue')
  module.exports = {
    ready: function () {
      Vue.http.interceptors.push(this.authenticationInterceptor)
      var lang = this.$route.query ? this.$route.query.lang : null
      if (lang) {
        this.changeLanguage(lang)
      }
      var auth = local.get('client.auth')
      if (auth) {
        var path = this.$route.path || '/'
//        if (!path || path === '/') {
//          path = '/'
//        }
        this.$emit('authenticate', auth, path)
      }
    },
    store: store,
    vuex: {
      getters: getters,
      actions: actions
    },
    components: {
      heading: require('./components/Heading'),
      footing: require('./components/Footer')
    },
    methods: {
      authenticationInterceptor: function (request, next) {
        var self = this
        next(function (response) {
          if (response.status === 401) {
            self.$emit('logout')
          }
        })
      }
    },
    data: function () {
      return {
        loading: false,
        error: {
          show: false,
          message: ''
        }
      }
    },
    events: {
      'show-success': function (data) {
        this.$els.successresult.MaterialSnackbar.showSnackbar({
          message: label(data),
          timeout: 2000
        })
      },
      'dismis-error': function () {
        this.error.show = false
      },
      'show-error': function (data) {
        this.$emit('loading', false)
        this.error.show = true
        this.error.message = data.message
      },
      authenticate: function (authData, redirect) {
        var self = this
        this.adminLogin(authData, function (err, result) {
          console.log(result)
          if (err) {
            self.$emit('show-error', err)
          } else {
            self.$emit('show-success', result)
            if (redirect) {
              self.$router.go(redirect)
            }
          }
        })
      },
      logout: function () {
        this.$emit('show-success', 'general.message.logout')
        this.logout()
        this.$router.go('/admin/login')
      },
      'loading': function (spin) {
        this.loading = spin
      }
    }
  }
</script>

<style scoped>
  main {
    display: flex;
    flex-direction: column;
  }
  section {
    flex: 1;
  }
</style>



// WEBPACK FOOTER //
// Admin.vue?7f942f0a